import React from 'react';
import ApartmentTherapy from './assets/apartment-therapy.svg';
import NyTimes from './assets/ny-times.svg';
import Vogue from './assets/vogue.svg';
import PeopleMagazine from './assets/people_magazine.svg';
import HouseBeautiful from './assets/house_beautiful.svg';

const logos = [
  <Vogue key="vogue" />,
  <NyTimes key="nytimes" />,
  <HouseBeautiful key="housebeautiful" />,
  <ApartmentTherapy key="apartment" />,
  <PeopleMagazine key="peoplemagazine" />,
];

const LogoWithQuote = [
  {
    key: 'vogue',
    Logo: Vogue,
    quote: `“Imagine if you could hire someone to scour your Pinterest boards and
        translate your pins into a perfectly decorated room in your home.”`
  },
  {
    key: 'nytimes',
    Logo: NyTimes,
    quote: `“Havenly — offering services that were affordable for everyone.”`
  },
  {
    key: 'house_beautiful',
    Logo: HouseBeautiful,
    quote: `“From creating the perfect layout to finding pieces I absolutely loved, my designer really took my space to the next level.”`
  },
  {
    key: 'peoplemagazine',
    Logo: PeopleMagazine,
    quote: `“Surprisingly easy and enjoyable, and a process I am looking forward to repeating!”`
  },
  {
    key: 'apartment',
    Logo: ApartmentTherapy,
    quote: `“Unlike [another design service] though, we actually loved everything we saw from Havenly.”`
  },
];

export { LogoWithQuote };

export default logos;
